import * as React from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { Dispatch } from 'redux';
import { useState } from 'react';
import { DABInlineLoading, DABTextBoxWithSearch } from '../../components/dab';
import { messageBoardAction } from '../../actions/messageBoardAction';
import moment from 'moment';
import ReactPaginate from 'react-paginate';

interface IUserMessagesProps {
	dispatch: Dispatch<any>;
	userId: any;
	showSearch: any;
	title: any;
	messageBoardData: any;
}

const UserMessage: React.SFC<IUserMessagesProps> =
	({ dispatch, userId, showSearch, title, messageBoardData }) => {

		const initialPublicMsgInputValue = {
			sortColumn: "date",
			sortDirection: "desc",
			pageNumber: 1,
			pageSize: 10,
			dashboardMessagesGetInput: {
				userId: userId,
				searchString: "",
				isPrivate: false
			}
		};
		const initialPrivateMsgInputValue = {
			sortDirection: 'desc',
			sortColumn: 'date',
			pageNumber: 1,
			pageSize: 10,
			dashboardMessagesGetInput: {
				userId: userId,
				searchString: "",
				isPrivate: true
			}
		};

		const initialChannelMsgInputValue = {
			searchString: "",
			userId: userId
		};

		const [showPublicModal, setShowPublicModal] = useState(false);
		const [showChannelModal, setShowChannelModal] = useState(false);
		const [publicMsgfilterInput, setPublicMsgFilterInput] = useState(initialPublicMsgInputValue);
		const [ChannelMsgfilterInput, setChannelMsgFilterInput] = useState(initialChannelMsgInputValue);
		const [publicMessageList, setPublicMessageList] = useState([]);
		const [publicMessagePageList, setPublicMessagePageList] = useState([1]);
		const [publicMessageCurrentPageNo, setPublicMessageCurrentPageNo] = useState(0);
		const [publicMsgSearchText, setPublicMsgSearchText] = useState("");
		const [channelMessageList, setChannelMessageList] = useState([]);
		const [channelMsgSearchText, setChannelMsgSearchText] = useState("");

		React.useEffect(() => {
			dispatch(messageBoardAction.messageBoardGetPublicMessageByUserId(publicMsgfilterInput));
			setShowPublicModal(true);
		}, [publicMsgfilterInput]);

		React.useEffect(() => {
			dispatch(messageBoardAction.messageBoardGetChannelMessageByUserId({ dashboardChannelMessagesGetInput: ChannelMsgfilterInput }));
			setShowChannelModal(true);
		}, [ChannelMsgfilterInput]);

		if (messageBoardData) {
			if (messageBoardData.isUserDashboardMsgLoaded) {
				messageBoardData.isUserDashboardMsgLoaded = false;
				setShowPublicModal(false);
				setPublicMessageList(messageBoardData.userDasboardMessageData);
				var total: number = messageBoardData.publicMessagesCount;
				var pList: number[] = [];
				if (total > initialPublicMsgInputValue.pageSize) {
					for (var i = 1; i <= (total / initialPublicMsgInputValue.pageSize); i++) {
						pList.push(i);
					}
					if ((total % initialPublicMsgInputValue.pageSize) > 0) {
						pList.push((parseInt((total / initialPublicMsgInputValue.pageSize).toString()) + 1));
					}
				}
				else {
					pList.push(1);
				}
				setPublicMessagePageList(pList);
			}

			if (messageBoardData.isUserDashboardChannelMsgLoaded) {
				messageBoardData.isUserDashboardChannelMsgLoaded = false;
				setShowChannelModal(false);
				setChannelMessageList(messageBoardData.userDasboardChannelMessageData);
			}

			if (!messageBoardData.isSuccess && messageBoardData.isError) {
				setShowChannelModal(false);
				setShowPublicModal(false);
				messageBoardData.isError = false
			}

		}

		const handleFilter = (isPrivate, isChannel) => {
			if (isChannel) {
				ChannelMsgfilterInput.searchString = channelMsgSearchText;
				dispatch(messageBoardAction.messageBoardGetChannelMessageByUserId({ dashboardChannelMessagesGetInput: ChannelMsgfilterInput }));
				setShowChannelModal(true);
			} else {
				publicMsgfilterInput.dashboardMessagesGetInput.searchString = publicMsgSearchText;
				dispatch(messageBoardAction.messageBoardGetPublicMessageByUserId(publicMsgfilterInput));
				setShowPublicModal(true);
			}
		};

		const handleInputChange = (event, isPrivate, isChannel) => {
			if (isChannel)
				setChannelMsgSearchText(event.target.value);
			else {
				setPublicMsgSearchText(event.target.value);
			}
		};

		return (
			<div>
				<h5>
					<span>{title}</span>
				</h5>
				<Row>
					<Col className="verCenter" lg="6">
						<h6>
							<span data-testid="messagePublicTitle">Public Messages</span>
						</h6>
					</Col>
					{showSearch && <>
						<Col lg="6" style={{ float: "right" }}>
							<DABTextBoxWithSearch type="search" id="searchText" isRequired={false}
								onChange={(event) => { handleInputChange(event, false, false) }}
								value={publicMsgSearchText} onClick={(event) => { handleFilter(false, false) }}
							/>
						</Col>
					</>
					}
				</Row>
				<table className="table table-bordered text-center" data-testid="messagePublicTable">
					<thead>
						<tr>
							<th data-testid="messagePublicDate" key="messagePublicDate" scope="col">Date</th>
							<th data-testid="messageBoardPublic" key="messageBoardPublic" scope="col">Message Board</th>
							<th data-testid="messagePublicSubject" key="messagePublicSubject" scope="col">Subject</th>
							<th data-testid="messagePublicReplies" key="messagePublicReplies" scope="col">Replies</th>
							<th data-testid="messagePublicReports" key="messagePublicReports" scope="col">Alerts</th>
						</tr>
					</thead>
					<tbody data-testid="messagePublicTableBody">
						{!showPublicModal && publicMessageList && publicMessageList.map((data: any, index) =>
							<tr data-testid={"messagePublicTr" + index} key={"messagePublicTr" + index}>
								<td data-testid={"messagePublicDate" + index} key={"messagePublicDate" + index}>
									{moment(data.createdAtUtc).format("MM/DD/YYYY")}
								</td>
								<td data-testid={"messageBoardPublic" + index} key={"messageBoardPublic" + index}>{data.title}</td>
								<td data-testid={"messagePublicSubject" + index} key={"messagePublicSubject" + index}>
									<a className="detail-link" href={"/messageboard?page=posts&id=" + data.messageId} data-testid={"messagePublicSubjectLink" + index}>{data.subject}</a>
								</td>
								<td data-testid={"messagePublicReplies" + index} key={"messagePublicReplies" + index}>{data.messageType == "topic" && data.replies}</td>
								<td data-testid={"messagePublicReports" + index} key={"messagePublicReports" + index}>
									{(data.reports > 0 &&
										<div><a className="detail-link" href={"/messageboard?page=report&id=" + data.messageId} data-testid={"messagePublicAlertsLink" + index}>{data.reports}</a></div>
									)}
								</td>
							</tr>
						)}
						{showPublicModal &&
							<tr>
								<td colSpan={5} style={{ verticalAlign: "middle" }}>
									<DABInlineLoading />
								</td>
							</tr>
						}
						{!showPublicModal && publicMessageList.length <= 0 &&
							<tr>
								<td colSpan={5} style={{ verticalAlign: "middle" }}>
									No Data Found
								</td>
							</tr>
						}

					</tbody>
				</table>
				<Row>
					<Col lg="6">
					</Col>
					<Col lg="6">
						<div className="pagination" style={{ float: 'right' }}>
							<ReactPaginate
								previousLabel={'Previous'}
								nextLabel={'Next'}
								breakLabel={'...'}
								pageCount={publicMessagePageList.length}
								marginPagesDisplayed={2}
								pageRangeDisplayed={5}
								onPageChange={(data) => {
									setPublicMsgFilterInput({ ...publicMsgfilterInput, pageNumber: data.selected + 1, });
									setPublicMessageCurrentPageNo(data.selected);
								}}
								forcePage={publicMessageCurrentPageNo}
								containerClassName={'pagination'}
								pageClassName={"page-item"}
								previousClassName={"page-item"}
								breakClassName={"page-item"}
								breakLinkClassName={"page-link"}
								nextClassName={"page-item"}
								pageLinkClassName={"page-link"}
								previousLinkClassName={"page-link"}
								nextLinkClassName={"page-link"}
								activeClassName={'active'}
							/>
						</div>
					</Col>
				</Row>

				<br />
				<Row >
					<Col className="verCenter" lg="6">
						<h6>
							<span data-testid="messageChannelTitle">Channel-Related Messages</span>
						</h6>
					</Col>
					{showSearch && <>
						<Col lg="6" style={{ float: "right" }}>
							<DABTextBoxWithSearch type="search" id="searchText" isRequired={false}
								onChange={(event) => { handleInputChange(event, false, true) }}
								value={channelMsgSearchText} onClick={(event) => { handleFilter(false, true) }}
							/>
						</Col>
					</>
					}
				</Row>
				<table className="table table-bordered text-center" data-testid="messageChannelTable">
					<thead>
						<tr>
							<th data-testid="messageChannelDate" key="messageChannelDate" scope="col">Date</th>
							<th data-testid="messageChannel" key="messageChannel" scope="col">Channel</th>
							<th data-testid="messageChannelSubject" key="messageChannelSubject" scope="col">Subject</th>
						</tr>
					</thead>
					<tbody data-testid="messageChannelTableBody">
						{!showChannelModal && channelMessageList && channelMessageList.map((data: any, index) =>
							<tr key={"messageChannelTr" + index}>
								<td data-testid={"messageChannelDate" + index} key={"messageChannelDate" + index} >
									{moment(data.createdAtUtc).format("MM/DD/YYYY")}
								</td>
								<td data-testid={"messageChannel" + index} key={"messageChannel" + index}>{data.title}</td>
								<td data-testid={"messageChannelSubject" + index} key={"messageChannelSubject" + index}><a className="detail-link" href={"/messageboard?page=posts&id=" + data.messageId} data-testid={"messageChannelSubjectLink" + index}>{data.subject}</a></td>
							</tr>
						)}
						{showChannelModal &&
							<tr>
								<td colSpan={3} style={{ verticalAlign: "middle" }}>
									<DABInlineLoading />
								</td>
							</tr>
						}
						{!showChannelModal && channelMessageList.length <= 0 &&
							<tr>
								<td colSpan={3} style={{ verticalAlign: "middle" }}>
									No Data Found
								</td>
							</tr>
						}

					</tbody>
				</table>				
			</div>
		);
	}

const mapStateToProps = (state: any) => {
	const { messageBoardData } = state;
	return {
		messageBoardData
	};
};

export default connect(mapStateToProps)(UserMessage);